import axios from '@/axios';
import store from '@/store';
import {removeStorage} from "@/Util/auth";

export default [
  {
    id: 1,
    title: "profile",
    action: ({ router }) => {
      router.push({ name: 'AdminProfile' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
  },
  {
    id: 2,
    title: "settings",
    action: ({ router }) => {
      router.push({ name: 'AdminSettings' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
  },
  {
    id: 3,
    title: "logout",
    action: async ({ router }) => {
      try {
        const logoutEndpoint = '/auth/logout';

        await axios.post(logoutEndpoint);
        removeStorage('auth');
        store.dispatch("user",null);
        // Redirect to appropriate login page
        router.push('/login');
      } catch (error) {
        console.error('Logout failed:', error);
      }
    },
  },

];
